import React, { useState } from 'react'
import { bool } from 'prop-types'
import RowMode from './RowMode'
import BulkMode from './BulkMode'

const AgentAddDrawer = props => {
  const [sendMode, setSendMode] = useState('rows')

  return sendMode === 'rows' ? (
    <RowMode {...props} setSendMode={setSendMode} />
  ) : (
    <BulkMode {...props} setSendMode={setSendMode} />
  )
}

AgentAddDrawer.propTypes = {
  open: bool.isRequired,
}

AgentAddDrawer.defaultProps = {}

export default AgentAddDrawer
